import Brett from "./Brett";
import {v3} from "oc-threejs/short3";

export default class Schrankboden extends Brett {

    // persistent (UserLayer) ------------------------------------------

    // transient (CompiledLayer) ---------------------------------------

    constructor(schrank) {
        super(schrank, 'Bodenplatte')
    }

    compile() {
        const outer = this.schrank.corpusBox;
        const inner = this.schrank.elementsBox;

        if (APP.settings.getBool('aussenwand_durchgehend_unten')){
            this.box = new THREE.Box3(
                v3(inner.min.x, inner.min.y - APP.settings.getFloat('boden_staerke'), outer.min.z),
                v3(inner.max.x, inner.min.y, inner.max.z)
            );
        }
        else{
            this.box = new THREE.Box3(
                v3(outer.min.x, inner.min.y - APP.settings.getFloat('boden_staerke'), outer.min.z),
                v3(outer.max.x, inner.min.y, inner.max.z)
            );
        }



        this.box.max.z -= APP.settings.getFloat('aussenwand_vorsprung', 0);

        this.boxToVertices();
        super.compile();
    }

}
